import { jsxs, jsx } from "react/jsx-runtime";
const IconCalendarSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M15.834 3.333h-1.667V2.5a.833.833 0 1 0-1.667 0v.833h-5V2.5a.833.833 0 0 0-1.666 0v.833H4.167a2.5 2.5 0 0 0-2.5 2.5v10a2.5 2.5 0 0 0 2.5 2.5h11.667a2.5 2.5 0 0 0 2.5-2.5v-10a2.5 2.5 0 0 0-2.5-2.5Zm.833 12.5a.833.833 0 0 1-.833.834H4.167a.833.833 0 0 1-.833-.834V10h13.333v5.833Zm0-7.5H3.334v-2.5A.833.833 0 0 1 4.167 5h1.667v.833a.833.833 0 0 0 1.666 0V5h5v.833a.833.833 0 1 0 1.667 0V5h1.667a.833.833 0 0 1 .833.833v2.5Z" })
    ]
  }
);
export {
  IconCalendarSvg
};
